(() => {
  if (window.kukurChristmasFamilyBound) return;
  window.kukurChristmasFamilyBound = true;
  const bind = (scope = document) => {
    for (const form of scope.querySelectorAll('[data-family-form]')) {
      if (form.dataset.bound) continue;
      form.dataset.bound = 'true';
      const members = [...form.querySelectorAll('[data-family-member]')];
      const status = form.querySelector('[data-family-status]');
      for (const member of members) {
        const include = member.querySelector('[data-family-include]');
        const select = member.querySelector('[data-family-variant]');
        const update = () => {
          select.disabled = !include.checked;
          select.required = include.checked;
          member.querySelector('input[type=hidden]').disabled = !include.checked;
          const option = select.selectedOptions[0];
          const link = member.querySelector('[data-family-product]');
          link.hidden = !option?.dataset.image;
          if (!link.hidden) {
            link.href = option.dataset.productUrl;
            const img = member.querySelector('[data-family-image]');
            img.src = option.dataset.image;
            img.alt = option.dataset.imageAlt;
          }
        };
        include.addEventListener('change', update);
        select.addEventListener('change', update);
        update();
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const items = members.filter(m => m.querySelector('[data-family-include]').checked)
          .map(m => ({id: Number(m.querySelector('[data-family-variant]').value), quantity: 1}));
        if (!items.length) { status.textContent = form.dataset.empty; return; }
        if (items.some(i => !i.id) || !form.reportValidity()) return;
        const button = form.querySelector('[data-family-submit]');
        button.disabled = true;
        status.textContent = '';
        try {
          const response = await fetch(`${form.action}.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || form.dataset.error);
          location.assign(form.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message || form.dataset.error;
          button.disabled = false;
        }
      });
    }
  };
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
